<template>
  <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.1667 59.3333C46.275 59.3333 59.3333 46.275 59.3333 30.1667C59.3333 14.0584 46.275 1 30.1667 1C14.0584 1 1 14.0584 1 30.1667C1 46.275 14.0584 59.3333 30.1667 59.3333Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M25 35L35 25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M25 25H35V35" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>